var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"py-3 text-center text-sm text-control-high md:py-2"},[_vm._v(" "+_vm._s(_vm.itemsStart)+" to "+_vm._s(_vm.itemsEnd)+" of "+_vm._s(_vm.numberOfItems)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }